import React from "react";

export const TriangleIcon: React.FC = () => (
  <svg width="9.367" height="13.158" viewBox="0 0 9.367 13.158">
    <g id="Polygon_1" data-name="Polygon 1" transform="matrix(1, -0.017, 0.017, 1, 0, 0.16)" fill="#169972">
      <path d="M 8.43565559387207 12.5 L 0.7058002352714539 12.5 L 4.570723533630371 1.507419943809509 L 8.43565559387207 12.5 Z" />
      <path
        d="M 4.570724010467529 3.01486873626709 L 1.411600112915039 12 L 7.729841232299805 12 L 4.570724010467529 3.01486873626709 M 4.570724964141846 0 L 9.141445159912109 13 L -4.76837158203125e-06 13 L 4.570724964141846 0 Z"
        stroke="none"
      />
    </g>
  </svg>
);
